// pages/resources/Blog.jsx
export default function Blog() {
  const posts = [
    {
      title: "10 Digital Advertising Trends to Watch in 2026",
      excerpt: "Stay ahead of the curve with these emerging trends shaping the future of digital advertising",
      author: "Sarah Johnson",
      date: "Feb 8, 2026",
      readTime: "8 min",
      category: "Trends"
    },
    {
      title: "How AI is Revolutionizing Ad Campaign Management",
      excerpt: "Discover how artificial intelligence is transforming the way we create and optimize campaigns",
      author: "Michael Chen",
      date: "Feb 5, 2026",
      readTime: "12 min",
      category: "Technology"
    },
    {
      title: "Mastering Facebook Ads: A Complete Guide",
      excerpt: "Everything you need to know about creating high-performing Facebook advertising campaigns",
      author: "Emily Rodriguez",
      date: "Feb 1, 2026",
      readTime: "15 min",
      category: "Tutorial"
    },
    {
      title: "The Psychology Behind Successful Ad Creatives",
      excerpt: "Understanding consumer psychology to create ads that resonate and convert",
      author: "David Park",
      date: "Jan 28, 2026",
      readTime: "10 min",
      category: "Strategy"
    },
    {
      title: "Budget Optimization: Getting More from Less",
      excerpt: "Proven strategies to maximize your advertising budget and improve ROI",
      author: "Lisa Anderson",
      date: "Jan 25, 2026",
      readTime: "9 min",
      category: "Budget"
    },
    {
      title: "Mobile-First Advertising in 2026",
      excerpt: "Why mobile-first approach is no longer optional and how to implement it effectively",
      author: "James Wilson",
      date: "Jan 20, 2026",
      readTime: "11 min",
      category: "Mobile"
    }
  ];

  const categories = ["All", "Trends", "Technology", "Tutorial", "Strategy", "Budget", "Mobile"];

  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl lg:text-6xl font-bold text-white mb-4">
            Adsurg Blog
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Expert insights, tips, and strategies to elevate your advertising game
          </p>
        </div>

        {/* Categories */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category, index) => (
            <button
              key={index}
              className={`px-6 py-2 rounded-xl font-medium transition-all ${
                index === 0
                  ? 'bg-gradient-to-r from-[#00809D] to-[#00a0c4] text-white shadow-lg shadow-[#00809D]/50'
                  : 'bg-gray-900 text-gray-400 border border-white/10 hover:border-[#00809D]/50 hover:text-white'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Blog Posts */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post, index) => (
            <article
              key={index}
              className="group bg-gradient-to-br from-gray-900 to-black border border-white/10 rounded-2xl overflow-hidden hover:border-[#00809D]/50 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#00809D]/20"
            >
              <div className="h-48 bg-gradient-to-br from-[#00809D]/20 to-[#00a0c4]/20 flex items-center justify-center border-b border-white/10">
                <svg className="w-16 h-16 text-[#00809D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                </svg>
              </div>

              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <span className="px-3 py-1 bg-[#00809D]/20 text-[#00809D] rounded-full text-xs font-semibold">
                    {post.category}
                  </span>
                  <span className="text-gray-500 text-sm">{post.readTime}</span>
                </div>

                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#00809D] transition-colors line-clamp-2">
                  {post.title}
                </h3>

                <p className="text-gray-400 mb-4 text-sm leading-relaxed line-clamp-3">
                  {post.excerpt}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-white/10">
                  <div className="text-sm">
                    <div className="text-white font-medium">{post.author}</div>
                    <div className="text-gray-500 text-xs">{post.date}</div>
                  </div>
                  <button className="text-[#00809D] font-semibold text-sm flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Load More */}
        <div className="text-center mt-12">
          <button className="bg-gradient-to-r from-[#00809D] to-[#00a0c4] text-white px-8 py-4 rounded-xl font-semibold hover:scale-105 transition-all shadow-lg shadow-[#00809D]/50">
            Load More Posts
          </button>
        </div>
      </div>
    </div>
  );
}
